import { newModel } from 'casbin.js';
import jwtDecode from 'jwt-decode';

export const model = newModel(`
  [request_definition]
  r = sub, obj, act

  [policy_definition]
  p = sub, obj, act, eft

  [role_definition]
  g = _, _

  [policy_effect]
  e = some(where (p.eft == allow)) && !some(where (p.eft == deny))

  [matchers]
  m = g(r.sub, p.sub) && keyMatch(r.obj, p.obj) && regexMatch(r.act, p.act)
`);

export const getPolicies = (token: string): string => {
  const policies: string[] = [];
  const decodedToken: Record<string, any> = jwtDecode(token);
  // const permissions: string[] = decodedToken.permissions || [];
  const permissions: string[] =
    decodedToken[process.env.REACT_APP_IDENTIFIER + 'permissions'] || [];

  for (const permission of permissions) {
    const [action, module] = permission.split(':');

    // if (action === 'read' && module !== 'purchase_price') {
    if (action === 'view' && module !== 'purchase_price') {
      policies.push(`p, user, ${module}, (list)`);
      policies.push(`p, user, ${module}/*, (show)`);
      continue;
    }
    if (action === 'update') {
      policies.push(`p, user, ${module}/*, (edit)`);
      continue;
    }
    if (action === 'delete') {
      policies.push(`p, user, ${module}/*, (${action})`);
      continue;
    }

    policies.push(`p, user, ${module}, (${action})`);
  }
  /** Commented out policies for now, can be re-enabled as needed */
  /*
  policies.push('p, user, dashboard, list');
  policies.push('p, user, templates, (list)|(create)');
  policies.push('p, user, templates/*, (edit)|(show)|(delete)');
  policies.push('p, user, variants, (list)|(create)');
  policies.push('p, user, variants/*, (edit)|(show)|(delete)');
  policies.push('p, user, product-variants, (list)|(create)');
  policies.push('p, user, product-variants/*, (edit)|(show)|(delete)');
  policies.push('p, user, pos, list');
  policies.push('p, user, restaurant-pos, list');
  policies.push('p, user, activity-history, list');
  policies.push('p, user, settings, (list)|(create)|(edit)|(show)|(delete)');
  */

  policies.push('p, user, dashboard, list');

  // policies.push('p, user, stock-correction-purchases, (list)|(create)');
  // policies.push('p, user, stock-correction-purchases/*, (edit)|(show)|(delete)');
  // policies.push('p, user, stock-correction-sales, (list)|(create)');
  // policies.push('p, user, stock-correction-sales/*, (edit)|(show)|(delete)');

  return policies.join('\n');
};
